var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"animated-counter",class:_vm.pulseClass},[_vm._v(_vm._s(_vm.displayText))])
}
var staticRenderFns = []

export { render, staticRenderFns }